<template>
    <rkm-modal
        extra-large
        ref="Modal"
        title="Procedimento secundário"
    >
        <Form
            :data="data"
            @save="handleSave"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                {{ data.model.exportado ? 'Fechar' : 'Cancelar' }}
            </rkm-button>

            <rkm-button
                v-if="!data.model.exportado"
                :disabled="!!loading"
                @click="$refs.Form.add()"
                color="primary"
            >
                {{ !item ? 'Incluir' : 'Salvar' }}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        item: null
    }),
    methods: {
        open(item = null) {

            this.item = item

            this.$refs.Modal.show()

            this.$nextTick().then(() => this.$refs.Form.load(item))
        },
        handleSave() {

            this.$refs.Modal.hide()
        },
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>